import { jeepRallyApi } from "../api";

const baseUrl = "/api/v1/categories";

export const getAllCategories = () => {
  return jeepRallyApi.get(baseUrl);
};

export const getCategoriesWithConsentForms = () => {
  return jeepRallyApi.get(`${baseUrl}/consent-forms`);
};

export const createCategory = (payload) => {
  return jeepRallyApi.post(baseUrl, payload);
};

export const updateCategory = (id, payload) => {
  return jeepRallyApi.patch(`${baseUrl}/${id}`, payload);
};

export const uploadCategoryConsentDocument = (id, file) => {
  const formData = new FormData();
  formData.append("consent_document", file);
  return jeepRallyApi.post(`${baseUrl}/${id}/consent`, formData);
};

export const deleteCategory = (id) => {
  return jeepRallyApi.delete(`${baseUrl}/${id}`);
};
